import mixpanel from 'mixpanel-browser'
import { defineNuxtPlugin, useRuntimeConfig } from '#app'

export default defineNuxtPlugin({
  parallel: false,
  setup (nuxtApp) {
    if (import.meta.client) {
      const config = useRuntimeConfig().public
      const token = (config.mixpanelToken as string) || ''
      const environment = config.environment as string

      mixpanel.init(token, {
        debug: environment === 'development',
        track_pageview: false,
        persistence: 'localStorage'
      } as any)

      // Make mixpanel available globally
      nuxtApp.provide('mixpanel', mixpanel)
    }
  }
})
